import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import ERPDataGrid from "../ERPDataGrid";
import "../ERPTheme.css";
import {baseUrl, ipAddress, userName} from "../Univ";
function InventoryTransferItem() {
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [transfers, setTransfers] = useState([]);
    const [items, setItems] = useState([]);
    const [editId, setEditId] = useState(null);
    const [formData, setFormData] = useState({
        transfer: "", item: "", quantity: ""
    });
    useEffect(() => {
        getTransferItems();
        getTransfers();
        getItems();
    }, []);
    const getTransferItems = () => {
        setLoading(true);
        axios
            .get(baseUrl + "inventory-transfer-item/")
            .then((res) => {
                setRows(res.data);
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
            });
    };
    const getTransfers = () => {
        axios
            .get(baseUrl + "inventory-transfer/")
            .then((res) => {
                setTransfers(res.data);
            });
    };
    const getItems = () => {
        axios
            .get(baseUrl + "inventory-item/")
            .then((res) => {
                setItems(res.data);
            });
    };
    const handleChange = (e) => {
        setFormData({
            ...formData, [e.target.name]: e.target.value
        });
    };
    const clearForm = () => {
        setEditId(null);
        setFormData({
            transfer: "", item: "", quantity: ""
        });
    };

    const deleteData = (id) => {
        Swal.fire({
            title: "Delete Transfer Item?", icon: "warning", showCancelButton: true
        }).then((result) => {
            if (result.isConfirmed) {
                axios
                    .delete(baseUrl + `delete-inventory-transfer-item/${id}/`)
                    .then(() => {
                        Swal.fire("Deleted", "", "success");
                        getTransferItems();
                    });
            }
        });
    };
    const saveData = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const data = new FormData();
            data.append("transfer", formData.transfer);
            data.append("item", formData.item);
            data.append("quantity", formData.quantity);
            data.append("addedby", userName);
            data.append("ip_add", ipAddress);

                await axios.post(baseUrl + "inventory-transfer-item/", data);

            Swal.fire("Success", editId === null ? "Transfer Item Saved" : "Transfer Item Updated", "success");

            getTransferItems();
        } catch (error) {
            Swal.fire("Error", "Unable to Save Transfer Item", "error");
        }
        setLoading(false);
    };
    const columns = [{
        field: "transfer", headerName: "Transfer", width: 220, renderCell: (params) => (<span>
            {params.row.transfer ? `Transfer #${params.row.transfer.id}` : "-"}
        </span>)
    }, {
        field: "item", headerName: "Item", width: 260, renderCell: (params) => (<span>
            {params.row.item ? params.row.item.item_name : "-"}
        </span>)
    }, {
        field: "quantity", headerName: "Quantity", width: 140
    }, {
        field: "action", headerName: "Action", width: 180, renderCell: (params) => (<>


                <button
                    className="btn btn-danger btn-sm"
                    onClick={() => deleteData(params.row.id)}
                >
                    Delete
                </button>

            </>)
    }];
    return (<div className="container-fluid mt-3">

            <div className="card shadow">

                <div className="card-header bg-success text-white">

                    <h5 className="mb-0">
                        Inventory Transfer Item
                    </h5>

                </div>

                <div className="card-body">

                    <form onSubmit={saveData}>

                        <div className="row">

                            <div className="col-md-4 mb-3">

                                <label>
                                    Transfer
                                </label>

                                <select
                                    className="form-control"
                                    name="transfer"
                                    value={formData.transfer}
                                    onChange={handleChange}
                                    required
                                >

                                    <option value="">
                                        Select Transfer
                                    </option>

                                    {transfers.map((transfer) => (<option
                                            key={transfer.id}
                                            value={transfer.id}
                                        >
                                            Transfer #{transfer.id}
                                        </option>))}

                                </select>

                            </div>


                            <div className="col-md-4 mb-3">

                                <label>
                                    Inventory Item
                                </label>

                                <select
                                    className="form-control"
                                    name="item"
                                    value={formData.item}
                                    onChange={handleChange}
                                    required
                                >

                                    <option value="">
                                        Select Item
                                    </option>

                                    {items.map((item) => (<option
                                            key={item.id}
                                            value={item.id}
                                        >
                                            {item.item_name}
                                        </option>))}

                                </select>

                            </div>


                            <div className="col-md-4 mb-3">

                                <label>
                                    Quantity
                                </label>

                                <input
                                    type="number"
                                    step="0.01"
                                    className="form-control"
                                    name="quantity"
                                    value={formData.quantity}
                                    onChange={handleChange}
                                    required
                                />

                            </div>

                            <div className="col-md-12 mt-3">


                                <button


                                    type="submit"


                                    className="btn btn-success me-2"


                                    disabled={loading}


                                >


                                    {editId === null ? "Save Transfer Item" : "Update Transfer Item"}


                                </button>


                                <button


                                    type="button"


                                    className="btn btn-secondary"


                                    onClick={clearForm}


                                >


                                    Clear


                                </button>


                            </div>


                        </div>


                    </form>


                </div>


            </div>

            <div className="card shadow mt-3">


                <div className="card-header bg-primary text-white">


                    <h5 className="mb-0">

                        Inventory Transfer Item List

                    </h5>


                </div>


                <div className="card-body">


                    <div

                        style={{
                            height: 600, width: "100%"
                        }}

                    >


                        <ERPDataGrid


                            rows={rows}


                            columns={columns}


                            loading={loading}


                            getRowId={(row) => row.id}


                            pageSizeOptions={[10, 25, 50, 100]}


                            disableRowSelectionOnClick


                        />


                    </div>


                </div>


            </div>


        </div>);
}
export default InventoryTransferItem;